import { render, staticRenderFns } from "./MarketingPromo.vue?vue&type=template&id=4e794437&"
import script from "./MarketingPromo.vue?vue&type=script&lang=js&"
export * from "./MarketingPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports